import { createContext } from "react";

const LanguageContext = createContext('en')

export default LanguageContext